export default {
      id: "pending-requirement-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#pending-requirement",
      toString: function () {
        return this.url;
      }
    }